import logoMarkUrl from '@locaveri/ui/assets/logo-mark.svg?url'

/**
 * Instala o favicon a partir do pacote de marca.
 *
 * O `index.html` não referencia o arquivo direto de propósito: a arte da marca
 * mora só em `@locaveri/ui/assets` e o Vite resolve/versiona a URL no build.
 * Assim não existe uma segunda cópia do logo para esquecer de atualizar.
 */
export function installFavicon(): void {
  const existente = document.querySelector<HTMLLinkElement>('link[rel="icon"]')
  const link = existente ?? document.createElement('link')

  link.rel = 'icon'
  link.type = 'image/svg+xml'
  link.href = logoMarkUrl

  if (existente === null) {
    document.head.appendChild(link)
  }
}
